import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-92">
      {/* Brillo de fondo específico para resaltar el oro */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-yellow-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-93" />

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block relative max-w-3xl mx-auto w-full" data-id="element-95">
          {/* Contenedor tipo Tarjeta Premium */}
          <div className="relative bg-gradient-to-b from-[#121212] to-[#0a0a0a] border border-yellow-500/30 p-8 md:p-14 rounded-[2.5rem] shadow-[0_0_60px_-15px_rgba(234,179,8,0.2)]" data-id="element-96">
            
            {/* Imagen del Sello 3D */}
            <div className="w-40 h-40 md:w-56 md:h-56 mx-auto mb-8 relative" data-id="element-97">
               {/* Resplandor detrás del sello */}
               <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-20 animate-pulse" data-id="element-98"></div>
               
               {/* TU NUEVO SELLO 3D GENERADO */}
               <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_hoi84zhoi84zhoi8.jpg?v=1770659983" alt="Garantía de Satisfacción 100%" className="w-full h-full object-contain relative z-10 drop-shadow-2xl transform hover:scale-105 transition-transform duration-500 rounded-full grayscale opacity-90 hover:grayscale-0 hover:opacity-100" data-id="element-99" />
            </div>

            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-100">
              GARANTÍA BLINDADA DE <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 drop-shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-101">7 DÍAS</span>
            </h2>

            <div className="space-y-5 text-gray-300 text-base md:text-xl leading-relaxed max-w-2xl mx-auto font-light" data-id="element-102">
              <p data-id="element-103">
                El riesgo está 100% de nuestro lado. No queremos tu dinero si no estás absolutamente seguro de que esta habilidad transformará tu futuro profesional.
              </p>
              <p data-id="element-104">
                Descarga el Masterkit, usa los comandos y aplica nuestra ruta paso a paso. Si en 7 días no sientes que tienes en tus manos la herramienta exacta para <span className="text-white font-bold" data-id="element-105">destacar, ahorrar tiempo y conseguir clientes internacionales</span>, envíanos un simple correo.
              </p>
              <p className="text-yellow-400 font-medium bg-yellow-500/5 py-2 px-4 rounded-lg border border-yellow-500/10" data-id="element-106">
                Te devolveremos el 100% de tu inversión al instante, y podrás quedarte con todos los bonos como un regalo por tu tiempo.
              </p>
              
              <div className="pt-6 mt-6 border-t border-white/10" data-id="element-107">
                <p className="font-bold text-yellow-500 text-xs md:text-sm tracking-[0.2em] uppercase" data-id="element-108">
                  SIN RIESGO • SIN PREGUNTAS • SIN LETRA PEQUEÑA
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}